const imageHostingURL = 'https://i.ytimg.com/vi/';
const embeddedYoutube = 'https://www.youtube.com/embed/';

export const validationRegex = /^(?:https?:\/\/)?(?:(?:www\.)?youtube.com\/watch\?v=|youtu.be\/(?!watch\?)).+$/;
export const idExtractionRegex = /(?:youtube.com\/watch\?v=|youtu.be\/(?!watch\?v=))([^&?]+)/;

/**
 * @param {string} url - link to youtube video
 * @return youtube video's id from url or undefined if link is invalid*/
export function extractVideoId(url) {
	const match = idExtractionRegex.exec(url);

	return match === null ? undefined : match[1]; 
}

/**
 * @param {string} id - youtube video's id
 * @return url to preview image. resolution: 320 x 180 */
export function previewPoster(id) {
	return `${imageHostingURL}${id}/mqdefault.jpg`;
}

/**
 * @param {string} id - youtube video's id
 * @return array of three urls to footage images. resolution: 120 x 90 */
export function previewFootages(id) { 
	return [
		`${imageHostingURL}${id}/1.jpg`,
		`${imageHostingURL}${id}/2.jpg`,
		`${imageHostingURL}${id}/3.jpg`
	];
}

/**
 * @param {string} url - link to youtube video
 * @return url to embedded youtube player */
export function embed(url) {
	const videoId = extractVideoId(url)

	return `${embeddedYoutube}${videoId}`;
}



// WEBPACK FOOTER //
// ./src/util/youtube.js